export default __webpack_public_path__ + "static/media/item-1.ce213c1e.webp";